export const occasionsWithDefaultDates = ['valentines', 'fathers day', 'mothers day']
export const occasionStrings = ['birthday' , 'anniversary' , 'valentines' , 'other', 'mothers day', 'fathers day', 'just because']
export const isWaitingListOn = false

export const RATING_VALUES = {
  positive: 1,
  negative: -1,
}
